/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_ZaloInputs */

const vi_shop_account_col_zalo = /** @type {(inputs: Shop_Account_Col_ZaloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo Mini App`)
};

/**

* @param {Shop_Account_Col_ZaloInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_zalo = /** @type {((inputs?: Shop_Account_Col_ZaloInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_ZaloInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_zalo(inputs)
});